export default __webpack_public_path__ + "static/media/amount-selected.36d87bff.svg";